import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-restricted',
  templateUrl: './restricted.component.html',
  styleUrl: './restricted.component.scss'
})
export class RestrictedComponent {
  constructor(private router: Router) {}
  gotoDashboard() {
    this.router.navigate([ 'main/dashboard' ]);
  }
}
